import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

/* jshint ignore:start*/
ReactDOM.render(<App />, document.querySelector("#root"));
/* jshint ignore:end*/
